module.exports = __webpack_public_path__ + "img/loader.e0debdae.svg";